import script from "./web-header.vue?vue&type=script&setup=true&lang=js"
export * from "./web-header.vue?vue&type=script&setup=true&lang=js"

import "./web-header.vue?vue&type=style&index=0&id=69e46847&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/qd-brcashy-h5-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69e46847"]])

export default __exports__